import { authManager } from "@/lib/managers/auth-manager";
import { BUGSNAG_META_TAB, buildUserData } from "@/lib/utils/bugsnag-content-helper";
import Bugsnag, { type NotifiableError } from "@bugsnag/js";

/**
 * Sends a Bugsnag error event with user data to the dashboard
 *
 * @param error - An error of type NotifiableError
 * @param context - Optional context to add to the event
 * @param metadata - Optional metadata to add to the event
 */
export const reportError = (
   error: NotifiableError,
   context?: string,
   metadata?: Record<string, { [key: string]: any }>,
) => {
   Bugsnag.notify(error, (event) => {
      const user = authManager.authedUser();
      if (user) {
         event.addMetadata(
            BUGSNAG_META_TAB.USER_DATA,
            buildUserData(user, authManager.activePermission),
         );
      }
      event.severity = "error";
      if (context) {
         event.context = context;
      }
      if (metadata) {
         Object.entries(metadata).forEach(([key, value]) => {
            event.addMetadata(key, value);
         });
      }
   });
};
